module.exports = __webpack_public_path__ + "static/media/LD_RL.36c1416c.webp";